// 加载 图片
// url 图片 地址 fullPath 表示 全路径
// 默认返回 {width: width / 200 + 'rem', height: height / 200 + 'rem'}rem 格式

// import Vue from 'vue';
// const vm = new Vue();
import sdk from './sdk';
import store from '@/store/index';

export const loadImagePromise = (url, fullPath) => {
	return new Promise((resolve) => {
		let img = new Image();
		img.onload = () =>
			resolve(
				fullPath
					? img
					: {
							width: img.width / 200 + 'rem',
							height: img.height / 200 + 'rem',
					  }
			);
		// img.onerror = reject;
		img.onerror = () => {};
		img.src = url;
	});
};

// 获取url参数
// http://wangwang.hhbgrd.com/pay/shopping?shop_id=0a772610-9450-445e-b5a8-bdd9ac358da8
export const getUrlParams = (name, url) => {
	if (!url) url = decodeURIComponent(window.location.href);
	name = name.replace(/[\[\]]/g, '\\$&'); // eslint-disable-line
	const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
	const results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const getRmKReferrerHref = (href) => {
	let kReferrer = getUrlParams('k_referrer');
	href = href ? href : location.href;
	if (kReferrer) {
		href = href.replace(/k_referrer=.+&/, '');
		href = href.replace(/k_referrer=.+$/, '');
		href = href.replace(/[&|\?]$/, '');
	}
	return href;
};

// 获取全部url参数
export const GetRequest = () => {
	var url = window.location.hash; // 获取url中"?"符后的字串
	var theRequest = new Object();
	if (url.indexOf('?') != -1) {
		var str = url.substr(url.indexOf('?') + 1);
		var strs = str.split('&');
		for (var i = 0; i < strs.length; i++) {
			theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
		}
	}
	return theRequest;
};
// url插入 参数
// https://developer.mozilla.org/fr/docs/Web/API/URLSearchParams 这个 需要引入 polyfill
// https://stackoverflow.com/questions/1090948/change-url-parameters/10997390#10997390
export const insertParam = (key, value, url) => {
	let TheAnchor = null;
	let newAdditionalURL = '';
	let tempArray = url.split('?');
	let baseURL = tempArray[0];
	let additionalURL = tempArray[1];
	let temp = '';

	if (additionalURL) {
		let tmpAnchor = additionalURL.split('#');
		let TheParams = tmpAnchor[0];
		TheAnchor = tmpAnchor[1];
		if (TheAnchor) additionalURL = TheParams;

		tempArray = additionalURL.split('&');

		for (let i = 0; i < tempArray.length; i++) {
			if (tempArray[i].split('=')[0] != key) {
				newAdditionalURL += temp + tempArray[i];
				temp = '&';
			}
		}
	} else {
		let tmpAnchor = baseURL.split('#');
		let TheParams = tmpAnchor[0];
		TheAnchor = tmpAnchor[1];

		if (TheParams) baseURL = TheParams;
	}

	if (TheAnchor) value += '#' + TheAnchor;

	const rows_txt = temp + '' + key + '=' + value;
	return baseURL + '?' + newAdditionalURL + rows_txt;
};

export const setLocalstorage = (key, data) => {
	localStorage[key] = JSON.stringify(data);
};

export const getLocalstorage = (key) => {
	const data = localStorage[key];
	return data ? JSON.parse(data) : '';
};

// vue-bus
export const VueBus = (Vue) => {
	const bus = new Vue();

	Object.defineProperties(bus, {
		on: {
			get() {
				return this.$on;
			},
		},
		once: {
			get() {
				return this.$once;
			},
		},
		off: {
			get() {
				return this.$off;
			},
		},
		emit: {
			get() {
				return this.$emit;
			},
		},
	});

	Vue.bus = bus;

	Object.defineProperty(Vue.prototype, '$bus', {
		get() {
			return bus;
		},
	});
};

export function countDownFormat2(countTime, millisecond, split, style) {
	// const t = countTime * 1000; // ms
	const t = +countTime; // m
	let h = Math.floor(t / 3600);
	let m = Math.floor((t - h * 3600) / 60);
	let s = Math.floor(t - h * 3600 - m * 60);
	h = h > 9 ? h : `0${h}`;
	m = m > 9 ? m : `0${m}`;
	s = s > 9 ? s : `0${s}`;
	if (millisecond) {
		const ts = countTime - h * 3600 - m * 60 - s;
		const ms = Math.floor(ts / 100);
		return `${h}:${m}:${s}.${ms}`;
	}
	if (split) {
		if (style) {
			return `<span class="countdown-item" style="${style}">${h}</span>
            : <span class="countdown-item" style="${style}">${m}</span>
            : <span class="countdown-item" style="${style}">${s}</span>`;
		}

		return `<span class="countdown-item">${h}</span>
            : <span class="countdown-item">${m}</span>
            : <span class="countdown-item">${s}</span>`;
	}

	return `${h}:${m}:${s}`;
}

export function countDownFormat(countTime, millisecond) {
	// const t = countTime * 1000; // ms
	const t = +countTime; // m
	let d = Math.floor(t / 86400);
	let h = Math.floor((t - d * 86400) / 3600);
	let m = Math.floor((t - d * 86400 - h * 3600) / 60);
	let s = Math.floor(t - d * 86400 - h * 3600 - m * 60);
	d = d ? `${d}天` : '';
	h = h > 9 ? h : `0${h}`;
	m = m > 9 ? m : `0${m}`;
	s = s > 9 ? s : `0${s}`;
	if (millisecond) {
		const ts = countTime - d * 86400 - h * 3600 - m * 60 - s;
		const ms = Math.floor(ts / 100);
		return `${d}${h}:${m}:${s}.${ms}`;
	}
	if (d > 0) {
		return `${d}${h}:${m}:${s}`;
	}
	return `${h}:${m}:${s}`;
}

/**
 * 防抖函数，返回函数连续调用时，空闲时间必须大于或等于 wait，func 才会执行
 *
 * @param  {function} func        回调函数
 * @param  {number}   wait        表示时间窗口的间隔
 * @param  {boolean}  immediate   设置为 true 时，是否立即调用函数
 * @return {function}             返回客户调用函数
 */
export function debounce(func, wait, immediate) {
	let timer, context, args;
	// 延迟执行函数
	const later = () =>
		setTimeout(() => {
			// 延迟函数执行完毕，清空缓存的定时器序号
			timer = null;
			// 延迟执行的情况下，函数会在延迟函数中执行
			// 使用到之前缓存的参数和上下文
			if (!immediate) {
				func.apply(context, args);
				context = args = null;
			}
		}, wait);

	// 这里返回的函数是每次实际调用的函数
	return function (...params) {
		// 如果没有创建延迟执行函数（later），就创建一个
		if (!timer) {
			timer = later();
			// 如果是立即执行，调用函数
			// 否则缓存参数和调用上下文
			if (immediate) {
				func.apply(this, params);
			} else {
				context = this;
				args = params;
			}
			// 如果已有延迟执行函数（later），调用的时候清除原来的并重新设定一个
			// 这样做延迟函数会重新计时
		} else {
			clearTimeout(timer);
			timer = later();
		}
	};
}

/**
 * 对比字符串版本号的大小，返回1则v1大于v2，返回-1则v1小于v2，返回0则v1等于v2
 *
 * @author
 * @param {string} v1 要进行比较的版本号1
 * @param {string} v2 要进行比较的版本号2
 * @returns
 */
export function versionCompare(v1, v2) {
	var GTR = 1; // 大于
	var LSS = -1; // 小于
	var EQU = 0; // 等于
	var v1arr = String(v1)
		.split('.')
		.map(function (a) {
			return parseInt(a);
		});
	var v2arr = String(v2)
		.split('.')
		.map(function (a) {
			return parseInt(a);
		});
	var arrLen = Math.max(v1arr.length, v2arr.length);
	var result;

	// 排除错误调用
	if (v1 == undefined || v2 == undefined) {
		throw new Error();
	}

	// 检查空字符串，任何非空字符串都大于空字符串
	if (v1.length == 0 && v2.length == 0) {
		return EQU;
	} else if (v1.length == 0) {
		return LSS;
	} else if (v2.length == 0) {
		return GTR;
	}

	// 循环比较版本号
	for (var i = 0; i < arrLen; i++) {
		result = xxcanghaiComp(v1arr[i], v2arr[i]);
		if (result == EQU) {
			continue;
		} else {
			break;
		}
	}
	return result;

	function xxcanghaiComp(n1, n2) {
		if (typeof n1 != 'number') {
			n1 = 0;
		}
		if (typeof n2 != 'number') {
			n2 = 0;
		}
		if (n1 > n2) {
			return GTR;
		} else if (n1 < n2) {
			return LSS;
		} else {
			return EQU;
		}
	}
}

/**
 * 生成 n-m 之间的一个随机数
 */
export function randomNum(minNum, maxNum) {
	switch (arguments.length) {
		case 1:
			return parseInt(Math.random() * minNum + 1, 10);
			break;
		case 2:
			return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
			break;
		default:
			return 0;
			break;
	}
}

export function crc32(str) {
	var makeCRCTable = function () {
		var c;
		var crcTable = [];
		for (var n = 0; n < 256; n++) {
			c = n;
			for (var k = 0; k < 8; k++) {
				c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
			}
			crcTable[n] = c;
		}
		return crcTable;
	};
	var crcTable = window.crcTable || (window.crcTable = makeCRCTable());
	var crc = 0 ^ -1;

	for (var i = 0; i < str.length; i++) {
		crc = (crc >>> 8) ^ crcTable[(crc ^ str.charCodeAt(i)) & 0xff];
	}

	return (crc ^ -1) >>> 0;
}

export function getDataTime() {
	const date = new Date();
	const year = date.getFullYear();
	let month = date.getMonth() + 1;
	let day = date.getDate();
	let hours = date.getHours();
	let mins = date.getMinutes();
	let secs = date.getSeconds();

	month = month > 9 ? month : `0${month}`;
	day = day > 9 ? day : `0${day}`;
	hours = hours > 9 ? hours : `0${hours}`;
	mins = mins > 9 ? mins : `0${mins}`;
	secs = secs > 9 ? secs : `0${secs}`;
	return `${year}-${month}-${day} ${hours}:${mins}:${secs}`;
}
export function getDate() {
	const date = new Date();
	const year = date.getYear() - 100;
	let month = date.getMonth() + 1;
	let day = date.getDate();

	month = month > 9 ? month : `0${month}`;
	day = day > 9 ? day : `0${day}`;
	return `${day}/${month}/${year}`;
}

/**
 * @description: 加载恭喜获得模块
 * @param {object} options - 参数
 * @param {string} options.type - 恭喜获得模块布局类型 replace or noDouble or double
 * @param {string} options.videoOverType - 翻倍视频看完后的恭喜获得模块布局类型 replace or noDouble or double
 * @param {string} options.rewardType - coin or musical 奖励类型 金币/音符
 * @param {number} options.rewardAmount - 奖励数量
 * @param {string} options.rewardTextExtra - 奖励额外文字 会拼接在'恭喜获得'之后
 * @param {string} options.bussiness - 埋点用，传入业务名称
 * @param {string} options.businessName - 业务名
 * @param {srring} options.videoOverbusinessName -领取自定义奖励后 所需业务名
 * @return {void}
 */

export function loadCongratulationsModule(options) {
	const {
		type = 'double',
		videoOverType = 'noDouble',
		rewardType = 'coin',
		rewardAmount = 0,
		rewardTextExtra = '',
		bussiness = '',
		businessName = '',
		videoOverbusinessName = '',
		position = '',
		businessMain = '',
		businessSub = '',
	} = options;
	const version = sdk.getUserInfo()['client-v'];
	const appName = store.getters.client['app-name'] || 'kuaiyin';
	console.log(appName);

	if (versionCompare(version, '3.11.0') !== -1) {
		const data = {
			url: `${appName}://congratulationsPopWindow?type=${type}&rewardType=${rewardType}&rewardAmount=${rewardAmount}&rewardTextExtra=${rewardTextExtra}&videoOverType=${videoOverType}&bussiness=${bussiness}&businessName=${businessName}&videoOverbusinessName=${videoOverbusinessName}&position=${position}&businessMain=${businessMain}&businessSub=${businessSub}`,
		};
		sdk.openPageWithJSON(JSON.stringify(data));
	}
}

export function throttle(fn, wait) {
	var pre = Date.now();
	return function () {
		var context = this;
		var args = arguments;
		var now = Date.now();
		if (now - pre >= wait) {
			fn.apply(context, args);
			pre = Date.now();
		}
	};
}



// WEBPACK FOOTER //
// ./src/lib/common.js